import { createContext, useContext } from 'react';
import { ModelsFundraisingEventModel as FundraisingEvent } from '../../api/agency-api';

export const NextEventContext = createContext<FundraisingEvent | null>(null);

export const useNextEvent = () => useContext(NextEventContext);
